import React, { useContext } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { useTranslation } from "react-i18next";
import AppContext from "../../../AppContext";

const DriverDailyTable = ({ data }) => {
  const { t } = useTranslation();
  const { darkMode } = useContext(AppContext);
  const renderCircleCell = (props) => {
    const { value, threshold } = props;
    let color;
    if (value <= threshold.low) {
      color = "green"; // Low warning
    } else if (value > threshold.low && value <= threshold.medium) {
      color = "orange"; // Medium warning
    } else {
      color = "red"; // High warning
    }
    return (
      <td>
        <div
          style={{
            width: 20,
            height: 20,
            borderRadius: "50%",
            backgroundColor: color,
            margin: "10px 20px",
          }}
        ></div>
      </td>
    );
  };

  const columns = [
    {
      field: "vehicle",
      title: t("masters.fields.vehicle"),
    },
    {
      field: "date",
      title: t("masters.fields.date"),
    },
    {
      field: "weekDayName",
      title: t("masters.fields.weekDay"),
      cell: (props) => {
        const { dataItem } = props;
        const weekday = dataItem.weekDayName;
        const cellValue =
          weekday === "Sunday" ? (
            <span style={{ color: "red" }}>{weekday}</span>
          ) : (
            weekday
          );
        return <td>{cellValue}</td>;
      },
    },
    {
      field: "highSpeed",
      title: t("masters.fields.highSpeed"),
      cell: (props) =>
        renderCircleCell({
          value: props.dataItem.highSpeed,
          threshold: { low: 50, medium: 75 },
        }),
    },
    {
      field: "highRpm",
      title: t("masters.fields.highRpm"),
      cell: (props) =>
        renderCircleCell({
          value: props.dataItem.highRpm,
          threshold: { low: 3000, medium: 3500 },
        }),
    },
    {
      field: "idleTime",
      title: t("masters.fields.idlTime"),
      cell: (props) =>
        renderCircleCell({
          value: props.dataItem.idleTime,
          threshold: { low: 6, medium: 10 },
        }),
    },
    {
      field: "doorOpened",
      title: t("masters.fields.safety"),
      cell: (props) =>
        renderCircleCell({
          value: props.dataItem.doorOpened,
          threshold: { low: 0.3, medium: 1 },
        }),
    },
  ];

  return (
    <div className={`h-full ${darkMode ? "darkGrid" : "lightGrid"}`}>
      <Grid style={{ height: "100%" }} data={data}>
        {columns.map((column, idx) => (
          <GridColumn
            key={idx}
            field={column.field}
            title={column.title}
            cell={column.cell}
          />
        ))}
      </Grid>
    </div>
  );
};

export default DriverDailyTable;
